import { HOME_SECTIONS } from "@/constants/testIds";

// A slow editorial marquee: Cormorant italic + Manrope uppercase interspersed with gold dots.
export default function Marquee() {
  const items = [
    { text: "Design That Moves Businesses Forward", type: "display" },
    { text: "16 Years", type: "meta" },
    { text: "Brand · Digital · Packaging · Communication", type: "display" },
    { text: "600+ Brands", type: "meta" },
    { text: "Bengaluru · Mumbai · Dubai · Singapore · London · New York", type: "display" },
    { text: "20,000+ Projects", type: "meta" },
  ];
  const row = [...items, ...items];

  return (
    <section
      data-testid={HOME_SECTIONS.marquee}
      className="relative overflow-hidden border-y border-ivory/[0.06] bg-ink-950 py-8 lg:py-12"
    >
      <div className="marquee-track flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <span
            key={i}
            className="mx-8 inline-flex items-center gap-6 lg:mx-14"
          >
            {item.type === "display" ? (
              <span className="font-display text-4xl italic leading-none tracking-tight text-ivory lg:text-6xl">
                {item.text}
              </span>
            ) : (
              <span className="font-sans text-[11px] uppercase tracking-widest text-gold">
                {item.text}
              </span>
            )}
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-gold/60" aria-hidden />
          </span>
        ))}
      </div>
    </section>
  );
}
